import { graphql, useStaticQuery, navigate } from "gatsby";
import React, { useState } from "react";
import GlobalContext from "../../../contexts/globalContext";
import Modal from "../../atoms/modal-pay/modal-pay";
import CardPay from "../../molecules/card-rates/card-rates";
import "./modal-pay.scss";

interface ShareModalInterface {
  open: boolean;
  onClose: Function;
  login: any;
  gigyaAccount: any;
}
const ModalPay = (props: ShareModalInterface) => {
  const { open, onClose, login, gigyaAccount } = props;
  const [bandera_log, setBanderaLog] = useState(false);
  const datas = useStaticQuery(graphql`
    query CostingQuery {
      allContentfulHome(filter: { titulo: { eq: "Home nutricion saludable" } }) {
        nodes {
          referenciaContenido {
            titulo
            tipoComponente
            tituloGeneral
            tituloBoton
            redireccionBoton
            descripcion {
              raw
            }
            referenciaPlantillaContenido {
              titulo
              redireccionBoton
              tituloBanner
              tituloBoton
              tituloDescripcion
              imagenPrincipal {
                file {
                  url
                }
                title
              }
              descripcion {
                raw
              }
            }
            redireccionBoton
          }
        }
      }
    }
  `);
  const costQuery = datas.allContentfulHome.nodes[0].referenciaContenido.filter(
    (el) => el.tipoComponente === "ModalDirectorio"
  );

  const navigatorService = () => {
    navigate("/servicios");
    setBanderaLog(false);
  };
  return (
    <GlobalContext.Consumer>
      {() => (
        <>
          <Modal
            open={open}
            onClose={() => onClose(false)}
            className={`m-share-modal `}
          >
            <div className={`m-share-modal__container `}>
              <div className="m-share-modal__container__header">
                <div className="m-share-modal__container__header__close">
                  <button
                    className="icon-close"
                    onClick={() => onClose(false)}
                  />
                </div>
              </div>
              <div className="m-share-modal__container__body">
                <h2>
                  {costQuery[0].tituloGeneral}
                  {bandera_log === true && gigyaAccount
                    ? navigatorService()
                    : ""}
                </h2>
                <h3>{JSON.parse(costQuery[0].descripcion.raw)}</h3>
              </div>
              <div>
                <CardPay
                  login={login}
                  datas={costQuery}
                  gigyaAccount={gigyaAccount}
                  onClose={onClose}
                  setBanderaLog={setBanderaLog}
                ></CardPay>
              </div>
            </div>
          </Modal>
        </>
      )}
    </GlobalContext.Consumer>
  );
};

export default ModalPay;
